import React, { useState, useEffect, useContext } from 'react'
import { Route, Routes, useNavigate, Navigate, redirect, useLocation } from "react-router-dom"
import { LocationContext } from './context/LocationContext.js';
import { roleContext } from './context/RoleContext.js';
import { authContext } from './context/AuthContext.js'
import Authorization from './pages/Authorization.jsx'
import Sidebar from './pages/Sidebar';
import Notfound from './pages/Notfound.jsx';
import Header from './pages/Header';
import ResetPassword from './pages/ResetPassword.jsx';
import Account from './pages/Account.jsx';
import ResetPasswordAccount from './pages/ResetPasswordAccount.jsx';
import PrivateOutlet from './components/Authorization/PrivateOutlet';
import useFetch from "./services/useFetch.js"
import CircularProgress from '@mui/material/CircularProgress';

// import ChangePassword from './components/Account/ChangePassword.jsx';
// import UserProfile from './components/Account/AccountPages/UserProfile.jsx';
import NewAccountResetPassword from './pages/NewAccountResetPassword.jsx';
import UploadLanding from './pages/UploadLanding.jsx';
import InventoryUploadLanding from './components/InventoryUpload/InventoryUploadLanding.jsx';
import NewEbayListing from './components/InventoryUpload/eBay Upload/NewEbayListing.jsx';
import NewShopifyListing from './components/InventoryUpload/Shopify Upload/NewShopifyListing.jsx';
import ManageAccount from './pages/ManageAccount.jsx';
import EbayAuthCallback from './pages/EbayAuthCallback.jsx';
import Shipping from './pages/Shipping.jsx';
import Orders from './pages/Orders.jsx';
import Fulfillment from './pages/Fulfillment.jsx';
import Returns from './pages/Returns.jsx';
import ShelfInventory from './pages/ShelfInventory.jsx';
import ShelfConfigs from './pages/ShelfConfigs.jsx';
import Configuration from './pages/Configuration.jsx';
import TreesList from './components/Inspections/TreesList.jsx';
import TreeBuilder from './components/Inspections/TreeBuilder.jsx';
import InspectionWizard from './components/Inspections/InspectionWizard.jsx';
import Products from './pages/Products.jsx';
import BuyerView from './pages/BuyerView.jsx';
import CatalogItems from './pages/CatalogItems.jsx';
import CatalogRecords from './pages/CatalogRecords.jsx';
import Invoices from './pages/Invoices.jsx';
import ReportingOrders from './pages/ReportingOrders.jsx';
import ReportingInventory from './pages/ReportingInventory.jsx';
import ReportingPurchasing from './pages/ReportingPurchasing.jsx';
import ReportingResearch from './components/Reporting/ReportingResearch.jsx';
import PrefetchGridLayouts from './components/Helpers/PrefetchGridLayouts.jsx';


export default function App() {
  const [reload, setReload] = useState(true)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Adjust the width as per your mobile breakpoint
  const location = useLocation();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener on mount
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const nav = useNavigate()

  // const { setLocationAccess, locationAccess } = useContext(LocationContext)
  const [key, setKey] = useState(false);

  const { user, isAuthenticated, isLoading, userRole, userName } = useContext(authContext)

  if (isLoading) {
    return (<div style={{ position: 'relative', top: '50%' }}>
      <CircularProgress size={25} sx={{ margin: '10% 48%' }} />
    </div>)
  }

  if (isLoading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", position: "relative", top: "40%" }}>
        <CircularProgress />
        <p style={{ marginTop: "8px", color: "#1976d2", width: "max-content" }}>Loading...</p>
      </div>
    )
  }
  return (
    // <div className="app">
    //   <div className='row' style={{ flexDirection: 'column' }}>
    //     {isAuthenticated && <Header
    //       // logout={logout}
    //       usrName={userName}
    //       reload={() => setKey(!key)}
    //       usrRole={userRole} />}
    //   </div>

    //   <div className='row' style={{ flexDirection: 'column', height: '100vh' }}>
    //     <roleContext.Provider value={userRole}>

    //       <div className="main-content">

    //         {isAuthenticated &&
    //           <Sidebar usrRole={userRole} isMobile={isMobile} />
    //         }
    <div className="app"
      style={{
        display: 'flex', flexDirection: 'column',
        height: '100vh', overflow: 'hidden', background: '#F1F5F9'
      }}>

      {isAuthenticated && (
        <Header
          usrName={userName}
          reload={() => setKey(!key)}
          usrRole={userRole}
        />
      )}
      {isAuthenticated && <PrefetchGridLayouts />}

      <div style={{ display: 'flex', flex: 1, overflow: 'hidden', background: '#F1F5F9' }}>
        <roleContext.Provider value={userRole}>

          {isAuthenticated && (
            <Sidebar />
          )}

          <main
            className="main-content"
            style={{
              flex: 1,
              backgroundColor: '#FFFFFF',
              margin: '0',
              borderRadius: '0',
              borderLeft: isAuthenticated ? '1px solid #E2E8F0' : 'none',
              padding: '0',
              overflowY: 'auto',
            }}
          >

            <div className={`${location.pathname === '/login' ? 'content-login' : 'content'}`} >
              {/* <div> */}
              <Routes>

                <Route exact path='/' element={<PrivateOutlet isAllowed={!!isAuthenticated} />} >
                  <Route index element={<Navigate to="/invoice-file-upload" replace />} />
                  <Route path="/invoice-file-upload" element={<UploadLanding />} />
                  <Route
                    path="/print-labels"
                    element={<Navigate to="/catalog-items?t=1" replace />}
                  />
                  <Route path="/upload-inventory" element={<InventoryUploadLanding />} />
                  <Route path="/shelf-inventory" element={<ShelfInventory />} />
                  <Route path="/shelf-configs" element={<ShelfConfigs />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/buyer-view" element={<BuyerView />} />
                  <Route path="/catalog-items" element={<CatalogItems />} />
                  <Route path="/catalog/:table" element={<CatalogRecords />} />
                  <Route path="/invoices" element={<Invoices />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/fulfillment" element={<Fulfillment />} />
                  <Route path="/returns" element={<Returns />} />
                  <Route path="/order-shipping" element={<Shipping />} />
                  <Route path="/reporting" element={<Navigate to="/reporting/orders" replace />} />
                  <Route path="/reporting/orders" element={<ReportingOrders />} />
                  <Route path="/reporting/inventory" element={<ReportingInventory />} />
                  <Route path="/reporting/purchasing" element={<ReportingPurchasing />} />
                  <Route path="/reporting/research" element={<ReportingResearch />} />
                  <Route path="/upload-inventory/new-ebay-listing" element={<NewEbayListing />} />
                  <Route path="/upload-inventory/new-shopify-listing" element={<NewShopifyListing />} />
                  <Route path="/configuration" element={<Configuration />} />
                  <Route path="/inspections/wizard" element={<InspectionWizard />} />
                  <Route path="/inspections/trees" element={<TreesList />} />
                  <Route path="/inspections/trees/:treeId" element={<TreeBuilder />} />
                </Route>

                <Route exact path='/' element={<PrivateOutlet isAllowed={!!isAuthenticated && userRole === "GlobalAdmin"} />} >
                  <Route index element={<Navigate to="/manage-account" replace />} />
                  <Route path="/manage-account" element={<ManageAccount />} />
                  <Route path="/tenant-setup/ebay-auth" element={<EbayAuthCallback />} />
                  <Route path="/tenant-auth/ebay-auth" element={<EbayAuthCallback />} />
                </Route>
                <Route path="/login" element={<Authorization />} />
                <Route path="/reset-password/account/:tokenKey" element={<ResetPasswordAccount />} />
                <Route path="/reset-password/new-account/:tokenKey" element={<NewAccountResetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />

                <Route path="/signup" element={<Authorization />} />
                <Route path="*" element={<Notfound />} />
              </Routes>

            </div>
            {/* </div> */}
            {/* </div> */}
          </main>
        </roleContext.Provider>
      </div >
    </div >
  );
}
